import React from "react";
import "./SkeletonLoader.scss";

const SkeletonLoader = ({ className = "" }) => {
  return <div className={`skeleton-shimmer-loader ${className}`}></div>;
};

export default SkeletonLoader;
